import { render, staticRenderFns } from "./baseball-game-detail.vue?vue&type=template&id=e0e885da&scoped=true&"
import script from "./baseball-game-detail.vue?vue&type=script&lang=js&"
export * from "./baseball-game-detail.vue?vue&type=script&lang=js&"
import style0 from "./baseball-game-detail.vue?vue&type=style&index=0&id=e0e885da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e885da",
  null
  
)

export default component.exports